<template>

  <v-navigation-drawer v-model="drawer" :clipped="clipped"
    :rail="windowWidth < 1024 ? false : !theme.drawer" permanent>
    <p class="mb-0 text-center" style="align-items: center; display: flex; justify-content: space-evenly">
      <img v-if="theme.drawer" class="pa-1 ma-1" height="56" :src="require('../assets/logo.svg')" />
      
    </p>
    <v-divider></v-divider>
    <v-list v-model:opened="open" class="nav">
      <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard" active-class="active" link to="/dashboard"></v-list-item>

       <v-list-item prepend-icon="mdi-google-analytics" title="Session" active-class="active" link to="/session"></v-list-item>

      <v-list-item prepend-icon="mdi-shuffle-variant" title="Vouchers" link active-class="active" to="/voucher"></v-list-item>
      <v-list-item prepend-icon="mdi-folder-network-outline" title="Trasaction History" link active-class="active" to="/trasaction-history"></v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { constants } from 'buffer';

export default {
  name: "Sidebar",
  data: () => ({
    drawer: true,
    windowWidth: window.innerWidth,
    clipped: true,
    open: ["Manage"],
    admins: [
      ["Survey", "mdi-account-multiple-outline"],
      ["Triggered Campaign", "mdi-cog-outline"],
      ["Marketing Campaign", "mdi-cog-outline"],
    ],
  }),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;

    },
    theme() {
      this.setDrawer();
      return this.$store.state.theme;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    setDrawer() {
      if (this.windowWidth < 1024) {
        this.drawer = this.$store.state.theme.drawer;
      } else {
        this.drawer = true;
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>
<style>
.nav .v-list-item {
  margin-bottom: 1px;
  width: 100%;
}

.nav .v-list-item:hover,
.v-list-item.active {
  background: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-white));
  border-radius: 0 50px 50px 0;
}

.nav .v-list-group__items .v-list-item {
  /* padding-inline-start: calc(-16px + var(--indent-padding)) !important; */
  padding-left: 24px !important;
}

.nav .third-level .v-list-group__items .v-list-item {
  padding-inline-start: 1px;
}

.nav .third-level.v-list-item {
  /* margin-left: -50px !important; */
  width: 100%;
  padding-left: 48px !important;
}

.nav .v-list-item-title {
  font-size: 0.9em !important;
  text-align: left;
}

.nav .v-list-item__prepend>.v-icon {
  margin-inline-end: 10px !important;
}
</style>
